import { Checkbox, Group } from '@mantine/core';
import { modals } from '@mantine/modals';
import { useTranslation } from 'locales';
import { useState } from 'react';
import { Document, Page } from 'react-pdf';
import { useHistory } from 'react-router-dom';
import { invoiceActions } from 'store/invoice/invoice.actions';

import ReminderPreview from './ReminderPreview';
import { RowAdornments } from './rowAdornments';

type Props = {
  item: any;
  isSelected: boolean;
  onToggleSelect: () => void;
};

export function RowLeadingCell({ item, isSelected, onToggleSelect }: Props) {
  const { t } = useTranslation();
  const history = useHistory();
  const [isPreviewLoading, setIsPreviewLoading] = useState<boolean>(false);

  const editClient = (target: any) => (event: React.MouseEvent) => {
    event.stopPropagation();
    history.push(`/clients/${target.debtor_id || target.id}/edit`);
  };

  const handlePdfView = () => {
    invoiceActions.document({
      id: item.id,
      type: 'invoice_pdf',
      callback: (data: any) => {
        const url = URL.createObjectURL(data);
        modals.open({
          size: '1100px',
          title: item.reference,
          children: (
            <Document file={url}>
              <Page
                renderAnnotationLayer={false}
                renderTextLayer={false}
                width={1100}
                pageNumber={1}
              />
            </Document>
          ),
        });
      },
    });
  };

  const handleReminderPreview = () => {
    setIsPreviewLoading(true);
    invoiceActions.previewTemplate({
      id: item.id,
      noLoading: true,
      data: {
        document_type: item.preview_template.step_type,
        template_id: item.preview_template.id,
        manual_reminder: false,
      },
      callback: (data: any) => {
        setIsPreviewLoading(false);
        modals.open({
          size: '1100px',
          title: item.recovery_step_id,
          children: <ReminderPreview email={data.email} pdf={data.pdf} />,
        });
      },
    });
  };

  return (
    <Group gap="xs" wrap="nowrap" align="center">
      <Checkbox
        size="sm"
        checked={isSelected}
        onChange={onToggleSelect}
        onClick={event => event.stopPropagation()}
      />
      <RowAdornments
        item={item}
        ctx={{
          t,
          groupedInvoices: item.invoices_references,
          isPreviewLoading,
          onShowReminderPreview: handleReminderPreview,
          onShowPdf: handlePdfView,
          onEditClient: editClient,
        }}
      />
    </Group>
  );
}
